import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "withdraw-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "balance-header flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-title header-5" }, "Opt Balance")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "withdraw-page-body" }
const _hoisted_4 = { class: "withdraw-input" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, "Withdrawal Amount", -1 /* HOISTED */)
const _hoisted_6 = { class: "withdraw-input-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "currency" }, "$", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "no-funds"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"withdraw-available\"><div class=\"available-container\"><div class=\"info-text\">Available after withdrawal</div><div class=\"amount\">$0</div></div></div><div class=\"withdraw-account-select\"><div class=\"withdraw-button-container\"><h2>Withdrawal Account</h2><span>Funds will be sent to the account you linked</span></div></div>", 2)
const _hoisted_11 = { class: "button-container withdraw-form-btns" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "withdraw-amount-input",
              type: "number",
              min: "balance",
              max: "balance",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.balance) = $event)),
              disabled: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $props.balance]
            ])
          ]),
          ($props.balance === 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_8, "You don't have any available funds to withdraw"))
            : _createCommentVNode("v-if", true)
        ]),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "borderless previous",
        onClick: $setup.previous
      }, "Back"),
      _createElementVNode("button", {
        class: "primary confirm-details",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.submitWithdraw())),
        disabled: !$setup.submitEnabled || $props.disabled
      }, "Submit", 8 /* PROPS */, _hoisted_12)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}